import React from 'react';
import { Link } from 'react-router-dom';

export function getPaginationItems(currentPage, totalPages) {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);
  if (currentPage <= 4) return [1, 2, 3, 4, 5, 'end-gap', totalPages];
  if (currentPage >= totalPages - 3) return [1, 'start-gap', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  return [1, 'start-gap', currentPage - 1, currentPage, currentPage + 1, 'end-gap', totalPages];
}

export default function Pagination({ page, totalPages, pageHref, ariaLabel, className = '' }) {
  if (totalPages <= 1) return null;

  return (
    <nav className={`retro-pagination ${className}`.trim()} aria-label={ariaLabel}>
      {page > 1 ? (
        <Link className="retro-page-button" to={pageHref(page - 1)} rel="prev">Poprzednia</Link>
      ) : (
        <span className="retro-page-button" aria-disabled="true">Poprzednia</span>
      )}
      <ul>
        {getPaginationItems(page, totalPages).map((item) => typeof item === 'number' ? (
          <li key={item} className={`page-item ${item === page ? 'active' : ''}`}>
            <Link className="page-link" to={pageHref(item)} aria-label={`Strona ${item}`} aria-current={item === page ? 'page' : undefined}>
              {item}
            </Link>
          </li>
        ) : (
          <li className="retro-pagination-gap" key={item} aria-hidden="true">…</li>
        ))}
      </ul>
      {page < totalPages ? (
        <Link className="retro-page-button" to={pageHref(page + 1)} rel="next">Następna</Link>
      ) : (
        <span className="retro-page-button" aria-disabled="true">Następna</span>
      )}
    </nav>
  );
}
